"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledHero = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

const StyledHero = _styledComponents.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  height: 90vh;\n  width: 100vw;\n  background-image: url(", ");\n  background-size: cover;\n  background-position: center center;\n  position: relative;\n\n  ", ";\n"])), _ref => {
  let {
    img
  } = _ref;
  return img;
}, _ref2 => {
  var _theme$components, _theme$components$her;

  let {
    theme
  } = _ref2;
  return theme === null || theme === void 0 ? void 0 : (_theme$components = theme.components) === null || _theme$components === void 0 ? void 0 : (_theme$components$her = _theme$components.hero) === null || _theme$components$her === void 0 ? void 0 : _theme$components$her.hero;
});

exports.StyledHero = StyledHero;